/* Proposed four-model P91 Builder capacity adapter. Loaded only by this isolated candidate. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.UPSBP91Capacity = factory();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var HANDLES = ['xpc-p91-1000', 'xpc-p91-1500', 'xpc-p91-2000', 'xpc-p91-3000'];
  var RATINGS = {'xpc-p91-1000':[1000,1000], 'xpc-p91-1500':[1500,1450],
    'xpc-p91-2000':[2000,1930], 'xpc-p91-3000':[3000,2880]};

  function validProjection(doc) {
    if (!doc || doc.schema !== 'builder-p91-capacity-projection/v1' || !doc.profiles ||
        doc.builder_commit !== 'bff4a65bcad64325cd83a0ba893b776d336fc28e' ||
        doc.builder_index_sha256 !== '4afe1063dd3588b2af7528f58b50a582091f1d95930c0b9b3aadf13d7028ebdd' ||
        doc.sidecar_sha256 !== '3faaa6b91ef83914ba12d8bc6160142199dedad008ee76eae536c6c4e63d9504' ||
        !doc.source || doc.source.flyer_pdf_sha256 !== 'fbd68fd39aa90358cac31c23e38f89536caae13e687ebd33dfc1b85c4d98f27e' ||
        doc.source.capacity_basis_footnote !== '***Capacities are based on highest selectable voltage. Some models\nderate at lower voltages' ||
        doc.source.current_revision_default_known !== false || doc.source.historical_max_output_v !== 125 ||
        Object.keys(doc.profiles).sort().join('|') !== HANDLES.slice().sort().join('|')) throw Error('P91 projection absent or wrong scope');
    HANDLES.forEach(function (h) {
      var p = doc.profiles[h];
      if (!p || p.handle !== h || p.nameplate.basis_output_v !== 127 ||
          p.nameplate.va !== RATINGS[h][0] || p.nameplate.w !== RATINGS[h][1] ||
          p.input_supply_code_in_current_index !== '120' ||
          p.nominal_output_v !== 120 || p.nominal_120_selectability !== 'not_established' ||
          p.current_factory_default_output_v !== null ||
          p.explicit_selectable_output_v.join('/') !== '100/110/115/127' ||
          [100, 110, 115, 120].some(function (v) {
            var c = p.capacity_by_output_v[String(v)];
            return !c || c.va !== null || c.w !== null || c.status !== 'not_established';
          }) ||
          p.capacity_by_output_v['127'].w !== p.nameplate.w ||
          p.capacity_by_output_v['127'].va !== p.nameplate.va ||
          p.capacity_by_output_v['127'].status !== 'nameplate_basis_only') throw Error('Unsafe P91 projection: ' + h);
    });
    return doc;
  }

  // q.power remains the wall/input supply. q.outputV must be a separate buyer/technician answer.
  // No caller-supplied boolean can turn this v1 review state into a purchase approval.
  function assess(doc, handle, q) {
    validProjection(doc);
    var p = doc.profiles[handle];
    if (!p) return null;
    if (!q || !Number.isFinite(q.load) || q.load <= 0) throw Error('Valid load watts required');
    var setting = q.outputV == null || q.outputV === '' ? null : Number(q.outputV);
    if (setting !== null && !Number.isInteger(setting)) throw Error('Invalid output setting');
    var state;
    if (q.load > p.nameplate.w) state = 'above_published_nameplate';
    else if (setting === null) state = 'output_setting_unknown';
    else if (setting === 127) state = 'published_basis_watt_candidate';
    else if (setting === 120) state = 'nominal_120_capacity_unestablished';
    else if (p.explicit_selectable_output_v.indexOf(setting) >= 0) state = 'lower_setting_capacity_unestablished';
    else state = 'requested_setting_not_in_current_flyer';
    return {
      handle: handle, state: state, requested_load_w: q.load,
      incoming_supply_v: q.power == null ? null : String(q.power),
      requested_output_v: setting,
      published_nameplate_va: p.nameplate.va, published_nameplate_w: p.nameplate.w,
      published_basis_output_v: 127, nominal_output_v: 120,
      selected_setting_confirmed_for_order: false,
      available_va_at_selected_setting: null,
      available_w_at_selected_setting: null,
      current_factory_default_output_v: null,
      runtime_chart_applicability_at_selected_setting: 'not_established',
      capacity_review_required: true,
      purchase_approved: false
    };
  }

  function isTarget(handle) { return HANDLES.indexOf(handle) >= 0; }

  // The four models are held even while the projection is missing or invalid.
  function assessSafe(doc, handle, q) {
    if (!isTarget(handle)) return null;
    try { return assess(doc, handle, q); }
    catch (error) {
      return { handle: handle, state: 'projection_unavailable',
        requested_load_w: q && q.load || null,
        incoming_supply_v: q && q.power == null ? null : String(q && q.power),
        requested_output_v: q && q.outputV || null,
        published_nameplate_va: null, published_nameplate_w: null,
        published_basis_output_v: 127, current_factory_default_output_v: null,
        available_va_at_selected_setting: null, available_w_at_selected_setting: null,
        runtime_chart_applicability_at_selected_setting: 'not_established',
        capacity_review_required: true, purchase_approved: false };
    }
  }

  function decorateOne(doc, e, q) {
    if (!e || !e.u || !isTarget(e.u.h)) return e;
    var copy = Object.assign({}, e);
    copy.p91Capacity = assessSafe(doc, e.u.h, q);
    copy.confirm = e.confirm + 1;
    copy.capacityFitStatus = 'potential_match_capacity_review';
    return copy;
  }

  function decorateSolutions(doc, results, q) {
    validProjection(doc);
    return results.map(function (e) {
      var review = assess(doc, e.u.h, q);
      if (!review) return e; // same object, preserving every non-target result and its ordering
      var copy = Object.assign({}, e);
      copy.p91Capacity = review;
      copy.confirm = e.confirm + 1;
      copy.capacityFitStatus = 'potential_match_capacity_review';
      return copy;
    });
  }

  function cartAllowed(e, existingCartEligible) {
    if (e && e.u && HANDLES.indexOf(e.u.h) >= 0) return false;
    return !!existingCartEligible;
  }

  return { validProjection: validProjection, assess: assess, assessSafe: assessSafe,
    isTarget: isTarget, decorateOne: decorateOne,
    decorateSolutions: decorateSolutions, cartAllowed: cartAllowed };
});
